import axios from 'axios';

import { QUICK_LINKS_SETTINGS_URL } from './constants';

const settings = {
    async getSettings() {
        return axios.get(QUICK_LINKS_SETTINGS_URL);
    },
};

export default settings;




// WEBPACK FOOTER //
// ./src/api/settings.js